exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-body {\n  padding-top: 0.6em; }\n\n.threshold-data {\n  margin: 0.2em 0;\n  padding: 0; }\n\n.right-align {\n  text-align: right; }\n\nmat-label {\n  font-weight: bold; }\n\n.modal-buttons {\n  float: right;\n  margin-top: 1.2em; }\n\n.modal-buttons button {\n  margin: 0 0.2em; }\n\n.error-message {\n  margin-top: 1em;\n  text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/components/threshold-modal/threshold-modal.component.scss
// module id = ../../../../../angular/app/components/threshold-modal/threshold-modal.component.scss
// module chunks = main